const PublishButtonTypes = {
  SUBMIT: 'submit',
  COS_UPDATE: 'cosUpdate',
  UPDATE: 'update',
  PUBLISH: 'publish'
};
export default PublishButtonTypes;